
console.log("hi");
const sliders = document.querySelectorAll('.wp-block-bytebot-slider-cover');

sliders.forEach((slider) => {
  const slides = slider.querySelectorAll('.cover-slide');
  const autoplay = slider.dataset.autoplay === 'true';
  const speed = parseInt(slider.dataset.speed, 10) || 5000;

  if (slides.length <= 1) return; // no need to slide

  let current = 0;

  // Initialize
  slides.forEach((slide, index) => {
    slide.style.position = 'absolute';
    slide.style.top = '0';
    slide.style.left = '0';
    slide.style.width = '100%';
    slide.style.height = '100%';
    slide.style.opacity = index === 0 ? '1' : '0';
    slide.style.transition = 'opacity 1s ease-in-out';
  });

  // Slide function
  const nextSlide = () => {
    slides[current].style.opacity = '0';
    current = (current + 1) % slides.length;
    slides[current].style.opacity = '1';
  };

  // Autoplay
  if (autoplay) {
    setInterval(nextSlide, speed);
  }
});
